module.exports = __webpack_public_path__ + "static/media/creativity.4b5ed114.jpg";